import { FORMLY_CONFIG } from '@ngx-formly/core';
import { NormalizeDelimitersOnBlurExtension } from './extensions/normalize-delimiters-on-blur.extension';
import { ResetOnChangeExtension } from './extensions/reset-on-change.extension';
import { AlertComponent } from './types/alert';
import { AnimalSpeciesAutocompleteComponent } from './types/animal-species-autocomplete/animal-species-autocomplete.component';
import { FormlyBeltCircumferenceRangeComponent } from './types/belt-circumference-range/formly-belt-circumference-range.component';
import { FormlyBeltCircumferenceComponent } from './types/belt-circumference/formly-belt-circumference.component';
import { CountriesAutocompleteComponent } from './types/countries-autocomplete/countries-autocomplete.component';
import { FormlyDatetimePickerComponent } from './types/datetime-picker/formly-datetime-picker.component';
import { EmailComponent } from './types/email/email.component';
import { FileInputComponent } from './types/file-input/file-input.component';
import { FrequencyInputComponent } from './types/frequency-input/frequency-input.component';
import { ImageSelectorComponent } from './types/image-selector/image-selector.component';
import { InfoWithDialogComponent } from './types/info-with-dialog/info-with-dialog.component';
import { InputComponent } from './types/input/input.component';
import { MultiInputComponent } from './types/multi-input/multi-input.component';
import { ObjectSelectComponent } from './types/object-select.component';
import { PhoneComponent } from './types/phone/phone.component';
import { FormlyRelativeTimeComponent } from './types/relative-time/formly-relative-time.component';
import { RepeatFixComponent } from './types/repeat-fix/repeat-fix.component';
import { FormlyScheduleComponent } from './types/schedule/formly-schedule.component';
import { SliderComponent } from './types/slider/slider.component';
import { StepperComponent } from './types/stepper/stepper.component';
import { TextareaComponent } from './types/textarea/textarea.component';
import { FormlyTimeSpanComponent } from './types/time-span/formly-time-span.component';
import { FormlyTimezoneSelectComponent } from './types/timezone-select/formly-timezone-select.component';
import { FormlyUserRolesComponent } from './types/user-roles/formly-user-roles.component';
import {
  delimitedIdsPatternValidator,
  delimiterValidator,
  maxItemsValidator,
} from './validators/delimited-ids-validators';
import { AlertWrapperComponent } from './wrappers/alert.wrapper';
import { FormlyApplyToAllWrapperComponent } from './wrappers/formly-apply-to-all.wrapper';
import { FormlyFormGroupWrapperComponent } from './wrappers/formly-form-group.wrapper';
import { FormlyPopoverWrapperComponent } from './wrappers/formly-popover.wrapper';

export const formlyConfig = {
  provide: FORMLY_CONFIG,
  multi: true,
  useValue: {
    wrappers: [
      { name: 'group', component: FormlyFormGroupWrapperComponent },
      { name: 'applyToAll', component: FormlyApplyToAllWrapperComponent },
      { name: 'popover', component: FormlyPopoverWrapperComponent },
      { name: 'alert', component: AlertWrapperComponent },
    ],
    extensions: [
      { name: 'normalizeDelimitersOnBlur', extension: new NormalizeDelimitersOnBlurExtension() },
      { name: 'resetOnChange', extension: new ResetOnChangeExtension() },
    ],
    types: [
      { name: 'alert', component: AlertComponent },
      { name: 'image-selector', component: ImageSelectorComponent },
      { name: 'belt-circumference', component: FormlyBeltCircumferenceComponent },
      { name: 'multi-input', component: MultiInputComponent },
      { name: 'repeat-fix', component: RepeatFixComponent },
      { name: 'timespan', component: FormlyTimeSpanComponent },
      { name: 'relative-time', component: FormlyRelativeTimeComponent },
      { name: 'timezone-select', component: FormlyTimezoneSelectComponent },
      { name: 'belt-circumference-range', component: FormlyBeltCircumferenceRangeComponent },
      {
        name: 'animal-species-autocomplete',
        component: AnimalSpeciesAutocompleteComponent,
        wrappers: [],
      },
      { name: 'countries-autocomplete', component: CountriesAutocompleteComponent },
      {
        name: 'input',
        component: InputComponent,
        wrappers: [],
      },
      {
        name: 'email',
        component: EmailComponent,
        wrappers: [],
      },
      {
        name: 'phone',
        component: PhoneComponent,
        wrappers: [],
      },
      {
        name: 'stepper',
        component: StepperComponent,
        wrappers: [],
      },
      { name: 'dialog-info', component: InfoWithDialogComponent, wrappers: [] },
      { name: 'datetime', component: FormlyDatetimePickerComponent, wrappers: [] },
      { name: 'object-select', component: ObjectSelectComponent },
      {
        name: 'file',
        component: FileInputComponent,
        wrappers: [],
      },
      {
        name: 'slider',
        component: SliderComponent,
        wrappers: [],
      },
      {
        name: 'frequency',
        component: FrequencyInputComponent,
        wrappers: [],
      },
      {
        name: 'textarea',
        component: TextareaComponent,
        wrappers: [],
      },
      {
        name: 'schedule',
        component: FormlyScheduleComponent,
      },
      {
        name: 'user-roles',
        component: FormlyUserRolesComponent,
        wrappers: [],
      },
    ],
    validators: [
      {
        name: 'maxItems',
        validation: maxItemsValidator,
      },
      {
        name: 'delimiter',
        validation: delimiterValidator,
      },
      {
        name: 'delimitedIds',
        validation: delimitedIdsPatternValidator,
      },
    ],
    validationMessages: [
      { name: 'required', message: 'This field is required' },
      { name: 'pattern', message: 'Invalid input format' },
      { name: 'email', message: 'Email is invalid' },
    ],
  },
};
